// src/components/auth/ForgotPasswordForm.tsx

import React, { useState } from 'react';
import { authAPI } from '../../api/auth.api.ts';
import './authForms.css';

interface ForgotPasswordFormProps {
  onBack: () => void;
}

export const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({ onBack }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email.trim()) {
      setError('Please enter your email address');
      return;
    }

    try {
      setLoading(true);
      setError(null);
      
      await authAPI.forgotPassword(email);
      setSuccess(true);
      
    } catch (err: any) {
      setError(err.message || 'Failed to send reset email');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="auth-form">
        <div className="success-icon" style={{ fontSize: '48px', textAlign: 'center', marginBottom: '16px' }}>
          📧
        </div>
        <h2>Check Your Email</h2>
        <p className="auth-subtitle">
          If an account exists for <strong>{email}</strong>, you'll receive a password reset link shortly.
        </p>
        <p style={{ color: '#666', fontSize: '14px', marginBottom: '24px', textAlign: 'center' }}>
          The link will expire in 1 hour. Check your spam folder if you don't see it.
        </p>
        <button 
          type="button" 
          className="auth-submit-btn"
          onClick={onBack}
        >
          Back to Sign In
        </button>
      </div>
    );
  }

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      <h2>Forgot Password?</h2>
      <p className="auth-subtitle">
        Enter your email address and we'll send you a link to reset your password.
      </p>

      {error && <div className="auth-error">{error}</div>}

      <div className="form-group">
        <label htmlFor="reset-email">Email</label>
        <input
          type="email"
          id="reset-email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your.email@example.com"
          required
          disabled={loading}
          autoComplete="email"
          autoFocus
        />
      </div>

      <button type="submit" className="auth-submit-btn" disabled={loading}>
        {loading ? 'Sending...' : 'Send Reset Link'}
      </button>

      <div className="auth-footer">
        Remember your password?{' '}
        <button type="button" className="link-btn" onClick={onBack}>
          Back to Sign In
        </button>
      </div>
    </form>
  );
};

export default ForgotPasswordForm;
